import React, { Component } from "react";
import SubHeader from "../../header/SubHeaderView.js";
import ViewModel from "./controllers/ViewModel.js";
import VouchersAFaturarV2View from "./view/VouchersAFaturarV2.js";

export default class VouchersAFaturarV2 extends Component {
  constructor(props) {
    super(props);
    this.viewModel = new ViewModel();
    this.viewModel.mirrorState = (s) => this.setState(s);
    this.viewModel.props = props;
  }

  componentDidMount() {
    this.viewModel.fetchData();
  }

  render() {
    return (
      <div className="page-content-wrapper">
        <SubHeader textoEsquerda="Relatórios" textoCentral="A Faturar" />
        <div className="page-content">
          <div className="container">
            <VouchersAFaturarV2View
              {...this.props}
              viewModel={this.viewModel}
            />
          </div>
        </div>
      </div>
    );
  }
}
